import api from "@/lib/api";

export interface PostContractRequest {
  transactionId: string;
}

export interface PostContractResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  // 通常契約登録 API
  postContractDefault(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "application/web-api/contract",
      method: "POST",
      body: data
    });
  },
  // Wacom 優待の契約登録 API
  postContractWacom(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "offers/wacom/web-api/contract",
      method: "POST",
      body: data
    });
  },
  // 既存顧客 優待の契約登録 API
  postContractContinued(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "offers/continued-patronage/web-api/contract",
      method: "POST",
      body: data
    });
  },
  // アクティベーションコードのWacom優待契約登録 API
  postContractActivationCodeWacomOffer(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "offers/activation-code/wacom/web-api/contract",
      method: "POST",
      body: data
    });
  },
  // Androidpkg経由の契約登録 API
  postContractPay(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "ice/application-pay/web-api/contract",
      method: "POST",
      body: data
    });
  },
  // DEBUTからの優待の契約登録 API
  postContractDebutOffer(data: any) {
    return api<PostContractRequest, PostContractResponse>({
      endpoint: "offers/debut/web-api/contract",
      method: "POST",
      body: data
    });
  }
};
